<template>
  <div>
    <ul class="search-condition">
      <template v-if="condition.parameter.userId">
        <li
          v-if="getConditionOrUndefined('userId')"
          style="display:inline-block"
          class="search-user-id"
        >
          会員ID：{{ condition.parameter.userId }}を選択
        </li>
      </template>
      <template v-else>
        <li
          v-if="getConditionOrUndefined('age.minimum')"
          style="display:inline-block"
          class="search-lower-age"
        >
          年齢下限：{{ condition.parameter.age.minimum }}歳
        </li>
        <li
          v-if="getConditionOrUndefined('age.maximum')"
          style="display:inline-block"
          class="search-upper-age"
        >
          年齢上限：{{ condition.parameter.age.maximum }}歳
        </li>
        <li
          v-if="getConditionOrUndefined('gender')"
          style="display:inline-block"
          class="search-gender"
        >
          性別：{{ convertLabel(condition.parameter.gender,'genders') }}
        </li>
        <li
          v-if="getConditionOrUndefined('educationalBackground')"
          style="display:inline-block"
          class="search-educational-background"
        >
          最終学歴：{{ convertLabel(condition.parameter.educationalBackground,'educationalBackgrounds') }}
        </li>
        <li
          v-if="getConditionOrUndefined('graduatedSchool.keywords') && getConditionOrUndefined('graduatedSchool.keywords').length"
          style="display:inline-block"
          class="search-graduated-school"
        >
          学校名/学部/学科/専攻：[{{ condition.parameter.graduatedSchool.keywords.join('、') }}] {{ condition.parameter.graduatedSchool.operator | parseOperator }}
        </li>
        <li
          v-if="graduationYear"
          style="display:inline-block"
          data-test="search-graduated-school-year"
        >
          卒業年：{{ graduationYear }}
        </li>
        <li
          v-if="getConditionOrUndefined('changeOverJobsCount.maximum') || getConditionOrUndefined('changeOverJobsCount.maximum') === 0"
          style="display:inline-block"
          class="search-changeover-jobs-count"
        >
          転職回数：{{ condition.parameter.changeOverJobsCount.maximum }}回以内
        </li>
        <li
          v-if="getConditionOrUndefined('employed') || getConditionOrUndefined('employed') === false"
          style="display:inline-block"
          class="search-employed"
        >
          就業状況：{{ condition.parameter.employed | convertEmployedLabel }}
        </li>
        <li
          v-if="getConditionOrUndefined('annualSalary.minimum')"
          style="display:inline-block"
          class="search-lower-annual-salary"
        >
          直近の年収下限：{{ condition.parameter.annualSalary.minimum }}万円
        </li>
        <li
          v-if="getConditionOrUndefined('annualSalary.maximum')"
          style="display:inline-block"
          class="search-upper-annual-salary"
        >
          直近の年収上限：{{ condition.parameter.annualSalary.maximum }}万円
        </li>
        <li
          v-if="getConditionOrUndefined('desiredSalary.minimum')"
          style="display:inline-block"
          class="search-lower-desired-salary"
        >
          希望年収下限：{{ condition.parameter.desiredSalary.minimum }}万円
        </li>
        <li
          v-if="getConditionOrUndefined('desiredSalary.maximum')"
          style="display:inline-block"
          class="search-upper-desired-salary"
        >
          希望年収上限：{{ condition.parameter.desiredSalary.maximum }}万円
        </li>
        <li
          v-if="getConditionOrUndefined('address.prefectures') && getConditionOrUndefined('address.prefectures').length && getConditionOrUndefined('address.selectedOption') === null"
          style="display:inline-block"
          class="search-prefectures"
        >
          {{ convertNonHopeUser('現住所・希望勤務地','address.containNonHopeUser') }}：[{{ condition.parameter.address.prefectures.map(id => convertLabelForLv2(id, 'prefectures')).join('、') }}]
        </li>
        <li
          v-else-if="getConditionOrUndefined('address.prefectures') && getConditionOrUndefined('address.prefectures').length && getConditionOrUndefined('address.selectedOption') === 'present'"
          style="display:inline-block"
          class="search-prefectures"
        >
          現住所：[{{ condition.parameter.address.prefectures.map(id => convertLabelForLv2(id, 'prefectures')).join('、') }}]
        </li>
        <li
          v-else-if="getConditionOrUndefined('address.prefectures') && getConditionOrUndefined('address.prefectures').length && getConditionOrUndefined('address.selectedOption') === 'desired'"
          style="display:inline-block"
          class="search-prefectures"
        >
          {{ convertNonHopeUser('希望勤務地', 'address.containNonHopeUser') }}：[{{ condition.parameter.address.prefectures.map(id => convertLabelForLv2(id, 'prefectures')).join('、') }}]
        </li>
        <li
          v-if="occupationOperatorLabel(getConditionOrUndefined('occupations.operator'))"
          style="display:inline-block"
          data-test="occupations-operator"
        >
          {{ occupationOperatorLabel(getConditionOrUndefined('occupations.operator')) }}
        </li>
        <li
          v-if="getConditionOrUndefined('occupations.experienced') && getConditionOrUndefined('occupations.experienced').length"
          style="display:inline-block"
          class="search-occupations"
        >
          経験職種：[{{ condition.parameter.occupations.experienced.map(x => occupationLabel(x)).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('occupations.desired') && getConditionOrUndefined('occupations.desired').length"
          style="display:inline-block"
          class="search-occupations"
        >
          {{ convertNonHopeUser('希望職種', 'occupations.containNonHopeUser') }}：[{{ condition.parameter.occupations.desired.map(x => occupationLabel(x, false)).join('、') }}]
        </li>
        <li
          v-if="businessOperatorLabel(getConditionOrUndefined('businesses.operator'))"
          style="display:inline-block"
          data-test="business-operator"
        >
          {{ businessOperatorLabel(getConditionOrUndefined('businesses.operator')) }}
        </li>
        <li
          v-if="getConditionOrUndefined('businesses.experienced') && getConditionOrUndefined('businesses.experienced').length"
          style="display:inline-block"
          class="search-sectors"
        >
          経験業種：[{{ condition.parameter.businesses.experienced.map(id => convertLabelForLv2(id, 'businesses')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('businesses.desired') && getConditionOrUndefined('businesses.desired').length"
          style="display:inline-block"
          class="search-sectors"
        >
          {{ convertNonHopeUser('希望業種', 'businesses.containNonHopeUser') }}：[{{ condition.parameter.businesses.desired.map(id => convertLabelForLv2(id, 'businesses')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('hasCareerResumes')"
          style="display:inline-block"
          class="search-has-career-resumes"
        >
          「職務経歴」登録済みのみ
        </li>
        <li
          v-if="condition.parameter.targetBehavior > 1"
          style="display:inline-block"
          class="search-target-behavior"
        >
          行動ターゲティング：{{ labelValueBehaviorByKey(condition.parameter.targetBehavior) }}
        </li>
        <li
          v-if="getConditionOrUndefined('activeRecent') || getConditionOrUndefined('activeRecent') === 0"
          style="display:inline-block"
          class="search-active-recent"
        >
          最終ログイン：{{ condition.parameter.activeRecent }}日以内
        </li>
        <li
          v-if="getConditionOrUndefined('toeicScore.minimum')"
          style="display:inline-block"
          class="search-toeic-score"
        >
          TOEIC：{{ condition.parameter.toeicScore.minimum }}点以上
        </li>
        <li
          v-if="getConditionOrUndefined('toeflScore.minimum')"
          style="display:inline-block"
          class="search-toefl-score"
        >
          TOEFL：{{ condition.parameter.toeflScore.minimum }}点以上
        </li>
        <li
          v-if="getConditionOrUndefined('englishSkill.minimum')"
          style="display:inline-block"
          class="search-english-skill"
        >
          英語スキル：{{ convertLabel(condition.parameter.englishSkill.minimum, 'languageSkills') }}
        </li>
        <li
          v-if="getConditionOrUndefined('changeJobsMotivations') && getConditionOrUndefined('changeJobsMotivations').length"
          style="display:inline-block"
          class="search-change-jobs-motivations"
        >
          転職意欲：{{ condition.parameter.changeJobsMotivations.map(id => convertLabel(id, 'changeJobsMotivations')).join('、') }}
        </li>
        <li
          v-if="getConditionOrUndefined('companyStyle')"
          style="display:inline-block"
          class="search-company-style"
        >
          希望している会社のタイプ：{{ convertLabel(condition.parameter.companyStyle, 'companyStyles') }}
        </li>
        <li
          v-if="getConditionOrUndefined('searchingOccupations') && getConditionOrUndefined('searchingOccupations').length"
          style="display:inline-block"
          class="search-searching-occupations"
        >
          職種で検索している会員を探す：[{{ condition.parameter.searchingOccupations.map(id => smallOccupationsLabelById(id)).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('searchingWorkPrefectures') && getConditionOrUndefined('searchingWorkPrefectures').length"
          style="display:inline-block"
          class="search-searching-work-prefectures"
        >
          勤務地で検索している会員を探す：[{{ condition.parameter.searchingWorkPrefectures.map(id => convertLabelForLv2(id, 'prefectures')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefined('searchingBusinesses') && getConditionOrUndefined('searchingBusinesses').length"
          style="display:inline-block"
          class="search-searching-sectors"
        >
          業種で検索している会員を探す：[{{ condition.parameter.searchingBusinesses.map(id => convertLabelForLv2(id, 'businesses')).join('、') }}]
        </li>
        <li
          v-if="getConditionOrUndefinedCondition('selectedRegistrationDateValue.terms') || getConditionOrUndefinedCondition('selectedRegistrationDateValue.terms') === 0"
          style="display:inline-block"
          class="search-registration-date"
        >
          登録時期：{{ condition.condition.selectedRegistrationDateValue.name }}
        </li>
        <template v-if="getConditionOrUndefined('registrationDate.selectedDateTimeWithinDays') === null">
          <li
            v-if="getConditionOrUndefined('registrationDate.selectedDateTimeRangeForm.from')"
            style="display:inline-block"
            class="search-registration-date-from"
          >
            登録時期From：{{ condition.parameter.registrationDate.selectedDateTimeRangeForm.from }}
          </li>
          <li
            v-if="getConditionOrUndefined('registrationDate.selectedDateTimeRangeForm.to')"
            style="display:inline-block"
            class="search-registration-date-to"
          >
            登録時期To：{{ condition.parameter.registrationDate.selectedDateTimeRangeForm.to }}
          </li>
        </template>
        <li
          v-if="getConditionOrUndefinedCondition('selectedResumeUpdateDateValue.terms') || getConditionOrUndefinedCondition('selectedResumeUpdateDateValue.terms') === 0"
          style="display:inline-block"
          data-test="search-resume-update-date"
        >
          レジュメ更新日：{{ condition.condition.selectedResumeUpdateDateValue.name }}
        </li>
        <template v-if="getConditionOrUndefined('resumeUpdateDate.selectedDateTimeWithinDays') === null">
          <li
            v-if="getConditionOrUndefined('resumeUpdateDate.selectedDateTimeRangeForm.from')"
            style="display:inline-block"
            data-test="search-resume-update-date-from"
          >
            レジュメ更新日From：{{ condition.parameter.resumeUpdateDate.selectedDateTimeRangeForm.from }}
          </li>
          <li
            v-if="getConditionOrUndefined('resumeUpdateDate.selectedDateTimeRangeForm.to')"
            style="display:inline-block"
            data-test="search-resume-update-date-to"
          >
            レジュメ更新日To：{{ condition.parameter.resumeUpdateDate.selectedDateTimeRangeForm.to }}
          </li>
        </template>
        <li
          v-if="getConditionOrUndefined('activeDate.from')"
          style="display:inline-block"
          class="search-active-date-from"
        >
          最終ログイン時期From：{{ condition.parameter.activeDate.from }}
        </li>
        <li
          v-if="getConditionOrUndefined('activeDate.to')"
          style="display:inline-block"
          class="search-active-date-to"
        >
          最終ログイン時期To：{{ condition.parameter.activeDate.to }}
        </li>
        <li
          v-if="getConditionOrUndefined('freeWord.keywords') && getConditionOrUndefined('freeWord.keywords').length"
          style="display:inline-block"
          class="search-free-word"
        >
          フリーワード：[{{ condition.parameter.freeWord.keywords.join('、') }}] {{ condition.parameter.freeWord.operator | parseOperator }}
        </li>
        <li
          v-if="getConditionOrUndefined('excludeWord.keywords') && getConditionOrUndefined('excludeWord.keywords').length"
          style="display:inline-block"
          class="search-exclude-word"
        >
          除外ワード：[{{ condition.parameter.excludeWord.keywords.join('、') }}] {{ condition.parameter.excludeWord.operator | parseOperator }}
        </li>
        <li
          v-if="getConditionOrUndefined('skills.conditions') && getConditionOrUndefined('skills.conditions').length"
          style="display:inline-block"
          class="search-skills"
        >
          スキル：[{{ skillsConditionLabel }}] {{ condition.parameter.skills.operator | parseOperator }}
        </li>
        <li
          v-if="getConditionOrUndefined('licenses.ids') && getConditionOrUndefined('licenses.ids').length"
          style="display:inline-block"
          class="search-licenses"
        >
          資格：[{{ condition.parameter.licenses.ids.map(id => licensesLabelById(id)).join('、') }}] {{ condition.parameter.licenses.operator | parseOperator }}
        </li>
        <li
          v-if="getConditionOrUndefined('excludedApproachedScout.otherCompany.maximum')"
          style="display:inline-block"
          data-test="approached-other-company"
        >
          他社からのスカウト受け取り数：{{ condition.parameter.excludedApproachedScout.otherCompany.maximum }}社以内
        </li>
        <li
          v-if="getConditionOrUndefinedCondition('selectedApproachedThisJobOptionValue.terms') || getConditionOrUndefinedCondition('selectedApproachedThisJobOptionValue.terms') === 0"
          style="display:inline-block"
          data-test="approached-this-job"
        >
          この自社求人のスカウト時期で除外：{{ condition.condition.selectedApproachedThisJobOptionValue.name }}
        </li>
        <template v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.thisJob.selectedDateTimeWithinDays') === null">
          <li
            v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from')"
            style="display:inline-block"
            data-test="approached-this-job-from"
          >
            From：{{ condition.parameter.excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from | parseDate }}
          </li>
          <li
            v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to')"
            style="display:inline-block"
            data-test="approached-this-job-to"
          >
            To：{{ condition.parameter.excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to | parseDate }}
          </li>
        </template>
        <li
          v-if="getConditionOrUndefinedCondition('selectedApproachedOtherJobOptionValue.terms') || getConditionOrUndefinedCondition('selectedApproachedOtherJobOptionValue.terms') === 0"
          style="display:inline-block"
          data-test="approached-other-job"
        >
          その他の自社求人のスカウト時期で除外：{{ condition.condition.selectedApproachedOtherJobOptionValue.name }}
        </li>
        <template v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.otherJob.selectedDateTimeWithinDays') === null">
          <li
            v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from')"
            style="display:inline-block"
            data-test="approached-other-job-from"
          >
            From：{{ condition.parameter.excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from | parseDate }}
          </li>
          <li
            v-if="getConditionOrUndefined('excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to')"
            style="display:inline-block"
            data-test="approached-other-job-to"
          >
            To：{{ condition.parameter.excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to | parseDate }}
          </li>
        </template>
        <li
          v-if="getConditionOrUndefinedCondition('selectedLikedOptionValue.terms') || getConditionOrUndefinedCondition('selectedLikedOptionValue.terms') === 0"
          style="display:inline-block"
          data-test="liked-date"
        >
          いいねを送信した時期を指定して除外：{{ condition.condition.selectedLikedOptionValue.name }}
        </li>
        <template v-if="getConditionOrUndefined('excludedApproachedLiked.selectedDateTimeWithinDays') === null">
          <li
            v-if="getConditionOrUndefined('excludedApproachedLiked.selectedDateTimeRangeForm.from')"
            style="display:inline-block"
            data-test="liked-date-from"
          >
            From：{{ condition.parameter.excludedApproachedLiked.selectedDateTimeRangeForm.from | parseDate }}
          </li>
          <li
            v-if="getConditionOrUndefined('excludedApproachedLiked.selectedDateTimeRangeForm.to')"
            style="display:inline-block"
            data-test="liked-date-to"
          >
            To：{{ condition.parameter.excludedApproachedLiked.selectedDateTimeRangeForm.to | parseDate }}
          </li>
        </template>
        <li
          v-if="getConditionOrUndefined('excludedCandidateOtherJob')"
          style="display:inline-block"
          data-test="excluded-candidate-other-company-job"
        >
          送信候補：その他の自社求人で送信候補に入れている会員を除外
        </li>
        <li
          v-if="getConditionOrUndefined('excludeEntryOtherCompanyJob') || getConditionOrUndefined('excludeCasualInterviewEntryOtherCompanyJob') "
          style="display:inline-block"
          data-test="exclude-entry-other-company-job"
          class="search-registration-date"
        >
          {{ getExcludeEntryOtherCompanyJobLabel }}
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import * as definition from '@/lib/labelValueMappings'
import { parseHierarchicalObjects } from '@/lib/parse'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { createDate } from '@/lib/dateUtils.js'

export default {
  name: 'SearchResultCondition',
  filters: {
    convertEmployedLabel (value) {
      return value || value === false ? definition.employed.find(employed => employed.value === value).name : ''
    },
    parseOperator (operator) {
      return operator === 'and' ? 'すべてを含む' : 'いずれかを含む'
    },
    parseDate (val) {
      return createDate(val)?.format('YYYY/MM/DD')
    }
  },
  props: {
    jobId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      conditionByJobId: 'membersSearchCondition',
      skillsMaster: 'skillsMaster'
    }),
    behaviorLabelValues () {
      return definition.behaviors
    },
    skillsConditionLabel () {
      if (!this.condition.parameter.skills || !this.condition.parameter.skills.conditions) return ''

      const experiences = this.getSkillExperiences(1)
      return Object.keys(experiences).map(key => {
        const experienceValues = _.at(experiences, key).reduce((arr, it) => (it) ? [...arr, ...it] : arr)
        experienceValues.map(val => {
          val.year = this.condition.parameter.skills.conditions.find(skill => Number(skill.id) === val.id).years.minimum
        })

        const subCategories = _.groupBy(experienceValues, val => {
          return val.path[0].name
        })

        return `${key}：` + Object.keys(subCategories).map(key => {
          return `[${key}]${subCategories[key].map(i => i.name + '（' + definition.searchSkillExperienceRange.find(item => item.id === i.year + '').name + '）').join('、')}`
        }).join('、')
      }).join('、')
    },
    condition () {
      return this.conditionByJobId(this.jobId)
    },
    graduationYear () {
      const from = this.getConditionOrUndefined('graduatedSchool.year.from')
      const to = this.getConditionOrUndefined('graduatedSchool.year.to')
      if (from && to) {
        return `${from}年〜${to}年`
      } else if (from) {
        return `${from}年〜`
      } else if (to) {
        return `〜${to}年`
      } else {
        return ''
      }
    },
    getExcludeEntryOtherCompanyJobLabel () {
      const excludeEntryOtherCompanyJobArray = []
      if (this.condition.parameter.excludeEntryOtherCompanyJob) {
        excludeEntryOtherCompanyJobArray.push(_.find(definition.excludeEntryOtherCompanyJob, { key: 'excludeEntryOtherCompanyJob' }).label)
      }
      if (this.condition.parameter.excludeCasualInterviewEntryOtherCompanyJob) {
        excludeEntryOtherCompanyJobArray.push(_.find(definition.excludeEntryOtherCompanyJob, { key: 'excludeCasualInterviewEntryOtherCompanyJob' }).label)
      }
      return `他求人への応募：${excludeEntryOtherCompanyJobArray.join('、')}`
    }
  },
  methods: {
    convertLabel (id, mastersKey) {
      return this.$store.getters.convertLabelById(id, mastersKey)
    },
    convertLabelForLv2 (id, mastersKey) {
      return this.$store.getters.convertLabelForLv2ById(id, mastersKey)
    },
    convertNonHopeUser (label, path) {
      if (this.getConditionOrUndefined(path)) {
        label = label + '(こだわらない・未入力の会員を含む)'
      }
      return label
    },
    smallOccupationsLabelById (id) {
      return this.$store.getters.lowerLayerLabel(id, 'occupations')
    },
    occupationLabel (occupation, showYearLabel = true) {
      // 経験職種(showYearLabel = true)・希望職種( showYearLabel = false)で呼ばれている
      const convertYearId = showYearLabel && (occupation.years.minimum !== null) ? _.toString(occupation.years.minimum) : null
      const yearLabel = showYearLabel ? `（${_.find(definition.searchOccupationExperienceRange, { id: convertYearId }).name}）` : ''
      return `${this.smallOccupationsLabelById(occupation.id)}${yearLabel}`
    },
    occupationOperatorLabel (key) {
      const experienced = this.getConditionOrUndefined('occupations.experienced') || []
      const desired = this.getConditionOrUndefined('occupations.desired') || []
      return experienced.length || desired.length ? _.find(definition.occupationOperators, { key: key }).label : ''
    },
    businessOperatorLabel (key) {
      const experienced = this.getConditionOrUndefined('businesses.experienced') || []
      const desired = this.getConditionOrUndefined('businesses.desired') || []
      return experienced.length || desired.length ? _.find(definition.businessOperators, { key: key }).label : ''
    },
    getConditionOrUndefined (path) {
      return _.get(this.condition.parameter, path)
    },
    getConditionOrUndefinedCondition (path) {
      return _.get(this.condition.condition, path)
    },
    hasKeyOfBehavior (key, targetBehavior) {
      let flg = false
      if (targetBehavior) {
        targetBehavior.forEach(x => {
          flg = x === key
        })
      }
      return flg
    },
    labelValueBehaviorByKey (key) {
      return _.find(definition.behaviors, { value: key }).label
    },
    licensesLabelById (id) {
      return this.convertLabelForLv2(id, 'licenses')
    },
    getSkillExperiences (groupLayer) {
      return _.groupBy(
        _.filter(parseHierarchicalObjects(this.skillsMaster), master => {
          return this.condition.parameter.skills.conditions.some(skill => Number(skill.id) === master.id)
        }),
        o => o.path[groupLayer].name
      )
    }
  }
}
</script>
